export default __webpack_public_path__ + "static/media/find_icon.7a845d5c.svg";